// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { FlexRow } from 'common/styles/oc-styled-components';
import { Icon } from 'opencare-crown';

// Component
const PromoCodeAlertMessage = ({ setAddPromoCodeVisibility }) => (
  <FlexRow
    align="center"
    justify="space-between"
    onClick={() => setAddPromoCodeVisibility(true)}
  >
    <div>Add promo code</div>
    <Icon role="presentation" type="plus" />
  </FlexRow>
);
PromoCodeAlertMessage.propTypes = {
  setAddPromoCodeVisibility: PropTypes.func,
};

export default PromoCodeAlertMessage;
